export const APPS_DESCUENTO = [
  { appUsuario: "Alumnos", nombre: "Académica", descripcion: "Sistema de alumnos" },
  { appUsuario: "Compras", nombre: "SGU", descripcion: "Sistema de compras" },
  { appUsuario: "Comedor", nombre: "Convenio", descripcion: "Sistema de comedor" },
];
export const nuevaConfiguracionDescuentos = () => ({ version: 3, general: null, menuUniversitarioAplicaDescuento: true, aplicaciones: APPS_DESCUENTO.map(({ appUsuario }) => ({ appUsuario, usarGeneral: false, porcentaje: null, tipos: [] })) });
// Unificar también los descuentos ya guardados y catálogos de una sesión previa.
export const normalizarTipoDescuento = (value) => {
  const tipo = String(value || "").trim();
  const clave = tipo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/gi, "").toLowerCase();
  return clave === "gestionacademica" ? "Gestión Académica" : tipo;
};
export const cargarDescuentos = (config) => {
  const base = nuevaConfiguracionDescuentos();
  return { ...base, ...config, aplicaciones: base.aplicaciones.map((grupo) => {
    const guardado = config?.aplicaciones?.find((g) => g.appUsuario === grupo.appUsuario);
    return { ...grupo, ...guardado, tipos: (guardado?.tipos || []).map((tipo) => ({ ...tipo, tipoUsuario: normalizarTipoDescuento(tipo.tipoUsuario) })) };
  }) };
};
export const problemaPorcentaje = (value) => {
  if (value == null || value === "") return null;
  const n = Number(value);
  return !Number.isFinite(n) || n < 0 || n > 100 || Math.abs(n * 100 - Math.round(n * 100)) > 1e-6 ? "Ingrese un porcentaje entre 0 y 100, con hasta dos decimales." : null;
};
export const limpiarDescuentos = (config, app = null) => ({ ...config, general: app ? config.general : null, aplicaciones: config.aplicaciones.map((g) => app && g.appUsuario !== app ? g : { ...g, porcentaje: null, tipos: g.tipos.map((t) => ({ ...t, porcentaje: null })) }) });
